// extracted by mini-css-extract-plugin
export default {"Logo":"Registration_Logo__negO3","Abstract":"Registration_Abstract__PACQz","backButton":"Registration_backButton__-FnuK"};